import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OpcoesPaginacao from '../comum/OpcoesPaginacao'
import alterarRegistrosPorPagina from '../../actions/fechamento-caixa/alterarRegistrosPorPaginaFechamentoCaixa'
import determinarPaginaAtual from '../../actions/fechamento-caixa/determinarPaginaAtuaFechamentoCaixa'

export class PaginacaoFechamentoCaixa extends Component {
  render () {
    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPaginaAtual}
      alterarRegistrosPorPagina={this.props.alterarRegistrosPorPagina}/>
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    alterarRegistrosPorPagina,
    determinarPaginaAtual
  }, dispatch)
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualFechamentoCaixa,
    total: state.fechamentosCaixa.total,
    registrosPorPagina: state.registrosPorPaginaFechamentoCaixa
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginacaoFechamentoCaixa)
